<template>
    <v-container fluid>
        <v-card v-model="options" multiple class="mb-5">
            <div class="overline pl-3 pt-3">
                Opções
            </div>
            <v-card-text>
                <v-row>
                    <v-col>
                        <v-select
                            label="Gerente de conta"
                            :items="accountManagers"
                            item-text="name"
                            item-value="value"
                            v-model="accountManager"
                            return-object
                            clearable
                            @click:clear="onClearAccountManager"
                        ></v-select>
                    </v-col>
                    <v-col>
                        <model-select
                            v-model="reseller"
                            :model="resellerModel"
                            name="reseller"
                            label="Parceiro"
                            item-text="trade_name"
                            item-value="id"
                            return-object
                            clearable
                            @click:clear="onClearReseller"
                            ref="resellerSelect"
                        />
                    </v-col>
                    <v-col>
                        <v-text-field
                            v-model="month"
                            label="Mês"
                            readonly
                            append-icon="mdi-calendar"
                            @click:append="datepicker = true"
                            @click="datepicker = true"
                        />
                    </v-col>
                </v-row>
                <v-dialog ref="dialog" v-model="datepicker" width="290px">
                    <v-date-picker
                        v-model="month"
                        type="month"
                        @input="datepicker = false"
                        scrollable
                    />
                </v-dialog>
            </v-card-text>
        </v-card>

        <v-row class="justify-center" v-if="data">
            <v-col
                cols="12"
                sm="12"
                xs="12"
                md="12"
                lg="12"
                v-if="data.resellers"
            >
                <indicator-group label="Parceiros" icon="mdi-account-tie">
                    <circle-indicator
                        :value="toNumber(data.resellers.total)"
                        label="Total"
                    />
                    <circle-indicator
                        :value="toNumber(data.resellers['1to499'])"
                        label="R$1 a R$499"
                        color="indigo"
                    />
                    <circle-indicator
                        :value="toNumber(data.resellers['500to999'])"
                        label="R$500 a R$999"
                        color="indigo"
                    />
                    <circle-indicator
                        :value="toNumber(data.resellers['1000to2999'])"
                        label="R$1000 a R$2999"
                        color="indigo"
                    />
                    <circle-indicator
                        :value="toNumber(data.resellers['3000to4999'])"
                        label="R$3000 a R$4999"
                        color="indigo"
                    />
                    <circle-indicator
                        :value="toNumber(data.resellers['5000to9999'])"
                        label="R$5000 a R$9999"
                        color="indigo"
                    />
                    <circle-indicator
                        :value="toNumber(data.resellers['moreThat10000'])"
                        label="Mais de R$10000"
                        color="indigo"
                    />
                    <circle-indicator
                        :value="toNumber(data.resellers['0upTo90Days'])"
                        label="R$0 até 90 dias"
                        color="red"
                    />
                    <circle-indicator
                        :value="toNumber(data.resellers['0upTo180Days'])"
                        label="R$0 90 a 180 dias"
                        color="red"
                    />
                    <circle-indicator
                        :value="toNumber(data.resellers['0moreThat180Days'])"
                        label="R$0 mais de 180 dias"
                        color="red"
                    />
                </indicator-group>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                xs="12"
                md="12"
                lg="12"
                v-if="data.customers"
            >
                <indicator-group label="Clientes" icon="mdi-account-group">
                    <circle-indicator
                        :value="toNumber(data.customers.total)"
                        label="Total"
                    />
                    <circle-indicator
                        :value="toNumber(data.customers['1to499'])"
                        label="R$1 a R$499"
                        color="indigo"
                    />
                    <circle-indicator
                        :value="toNumber(data.customers['500to999'])"
                        label="R$500 a R$999"
                        color="indigo"
                    />
                    <circle-indicator
                        :value="toNumber(data.customers['1000to2999'])"
                        label="R$1000 a R$2999"
                        color="indigo"
                    />
                    <circle-indicator
                        :value="toNumber(data.customers['3000to4999'])"
                        label="R$3000 a R$4999"
                        color="indigo"
                    />
                    <circle-indicator
                        :value="toNumber(data.customers['5000to9999'])"
                        label="R$5000 a R$9999"
                        color="indigo"
                    />
                    <circle-indicator
                        :value="toNumber(data.customers['moreThat10000'])"
                        label="Mais de R$10000"
                        color="indigo"
                    />
                    <circle-indicator
                        :value="toNumber(data.customers['0upTo90Days'])"
                        label="R$0 até 90 dias"
                        color="red"
                    />
                    <circle-indicator
                        :value="toNumber(data.customers['0upTo180Days'])"
                        label="R$0 90 a 180 dias"
                        color="red"
                    />
                    <circle-indicator
                        :value="toNumber(data.customers['0moreThat180Days'])"
                        label="R$0 mais de 180 dias"
                        color="red"
                    />
                </indicator-group>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                xs="12"
                md="12"
                lg="6"
                v-if="data && data.bookings"
            >
                <indicator-group label="Cancelados" icon="mdi-account-cancel">
                    <plain-indicator
                        icon="mdi-account-tie"
                        label="Parceiros"
                        :value="toNumber(data.resellers.canceled)"
                        :sub="'Total'"
                        color="red"
                        v-if="data && data.resellers"
                    />
                    <plain-indicator
                        icon="mdi-account-group"
                        label="Clientes"
                        :value="toNumber(data.customers.canceled)"
                        :sub="'Total'"
                        color="red"
                        v-if="data && data.customers"
                    />
                </indicator-group>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                xs="12"
                md="12"
                lg="6"
                v-if="data && data.bookings"
            >
                <indicator-group label="bookings" icon="mdi-account-tie">
                    <plain-indicator
                        icon="mdi-account-group"
                        label="Total"
                        :value="toNumber(data.bookings.amountTotal)"
                        :sub="$n(data.bookings.valueTotal, 'currency')"
                    />
                    <plain-indicator
                        icon="mdi-account-group"
                        label="No mês"
                        :value="toNumber(data.bookings.amountMonth)"
                        :sub="$n(data.bookings.valueMonth, 'currency')"
                    />
                </indicator-group>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                xs="12"
                md="12"
                lg="3"
                v-if="accountManager && data && data.engagement"
            >
                <indicator-group label="Positivação" icon="mdi-account-tie">
                    <plain-indicator
                        icon="mdi-account-group"
                        label="Total"
                        :value="toNumber(data.engagement.amount)"
                        :sub="data.engagement.percentage ? $n(10 * data.engagement.percentage, 'percent') : '0%'"
                    />
                </indicator-group>
            </v-col>
            <v-col
                cols="12"
                sm="6"
                xs="6"
                md="6"
                lg="3"
                v-if="data && data.overdues"
            >
                <indicator-group label="Inadimplência" icon="mdi-account-tie">
                    <plain-indicator
                        icon="mdi-account-group"
                        label="Total"
                        :value="toNumber(data.overdues.amount)"
                        :sub="data.overdues.value ? $n(data.overdues.value, 'currency') : 'R$0,00'"
                    />
                </indicator-group>
            </v-col>
            <v-col
                cols="12"
                sm="6"
                xs="6"
                md="6"
                lg="3"
                v-if="data && data.churns"
            >
                <indicator-group label="Churns" icon="mdi-account-tie">
                    <plain-indicator
                        icon="mdi-account-group"
                        label="Total"
                        :value="toNumber(data.churns.amount)"
                        :sub="data.churns.value ? $n(data.churns.value, 'currency') : 'R$0,00'"
                    />
                </indicator-group>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                xs="12"
                md="12"
                lg="6"
                v-if="data && data.leads"
            >
                <indicator-group label="prospects" icon="mdi-account-tie">
                    <plain-indicator
                        icon="mdi-account-group"
                        label="Total"
                        :value="toNumber(data.leads.amountTotal)"
                    />
                    <plain-indicator
                        icon="mdi-account-group"
                        label="No mês"
                        :value="toNumber(data.leads.amountMonth)"
                    />
                </indicator-group>
            </v-col>
            <v-col
                cols="12"
                sm="12"
                xs="12"
                md="12"
                lg="6"
                v-if="data && data.trials"
            >
                <indicator-group label="contas trials" icon="mdi-account-tie">
                    <plain-indicator
                        icon="mdi-account-group"
                        label="Total"
                        :value="toNumber(data.trials.amountTotal)"
                    />
                    <plain-indicator
                        icon="mdi-account-group"
                        label="No mês"
                        :value="toNumber(data.trials.amountMonth)"
                    />
                </indicator-group>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Reseller from '@/models/Reseller'
import User from '@/models/User'
import moment from 'moment'
import CircleIndicator from '@/components/indicators/CircleIndicator'
import IndicatorGroup from '@/components/indicators/IndicatorGroup'
import PlainIndicator from '@/components/indicators/PlainIndicator'
import ModelSelect from '@/shared/inputs/ModelSelect'

export default {
    components: {
        CircleIndicator,
        IndicatorGroup,
        PlainIndicator,
        ModelSelect,
    },

    data: () => ({
        options: [0],
        data: null,
        accountManagers: [],
        accountManager: null,
        reseller: null,
        resellerModel: new Reseller(),
        datepicker: null,
        month: moment().format('YYYY-MM'),
    }),

    watch: {
        accountManager(value) {
            if (value) {
                if (this.reseller) {
                    this.reseller = null
                }
                this.refreshData()
                return
            }

            this.refreshData()
        },
        reseller(value) {
            if (value) {
                this.accountManager = null
                this.refreshData()
                return
            }

            this.resetResellerSelect()
            this.refreshData()
        },
        month() {
            this.refreshData()
        },
    },
    methods: {
        onClearAccountManager() {
            this.accountManager = null
        },
        onClearReseller() {
            this.reseller = null
            this.resetResellerSelect()
        },
        resetResellerSelect() {
            const select = this.$refs.resellerSelect

            if (!select) {
                return
            }

            select.resetSearch()
            select.resetItems()

            if (!select.expanded) {
                select.fetchItems()
            }
        },
        async refreshData() {
            if (this.reseller) {
                const response = await this.$http.get(
                    `dashboard/byReseller?id=${this.reseller.id}&month=${this.month}`,
                )
                this.data = response.data
                return
            }

            if (this.accountManager) {
                const response = await this.$http.get(
                    `dashboard/byAccountManager?id=${this.accountManager.id}&month=${this.month}`,
                )
                this.data = response.data
                return
            }

            this.data = null
        },
        toNumber(value) {
            if (value === null || value === undefined) {
                return 0
            }

            const parsed = Number(value)

            return Number.isNaN(parsed) ? 0 : parsed
        },
    },

    created() {
        new User()
            .filter('accountManagers')
            .all()
            .then(accountManagers => {
                this.accountManagers = accountManagers.data
            })
    },
}
</script>

<style></style>
